import type { MessageKey } from "../../shared/i18n";

const ERROR_KEYS: Readonly<Record<string, MessageKey>> = {
  channel_disabled: "billing.error.channel_disabled",
  channel_unavailable: "billing.error.channel_unavailable",
  already_pro: "billing.error.already_pro",
  checkout_in_progress: "billing.error.checkout_in_progress",
  checkout_intent_conflict: "billing.error.checkout_intent_conflict",
  billing_disabled: "billing.error.billing_disabled",
  product_not_offered: "billing.error.product_not_offered",
};

/** True when the server answered (any status); false for a network failure. */
export function gotServerResponse(cause: unknown): boolean {
  if (!(cause instanceof Error)) return false;
  const status = (cause.cause as { status?: unknown } | undefined)?.status;
  return typeof status === "number";
}

/** Message for a failed checkout: a known 409 code, else the generic one. */
export function checkoutErrorKey(cause: unknown): MessageKey {
  const code =
    cause instanceof Error
      ? (cause.cause as { code?: unknown } | undefined)?.code
      : undefined;
  return (
    (typeof code === "string" ? ERROR_KEYS[code] : undefined) ??
    "profile.upgradeFailed"
  );
}

/** Kopecks to a localized ruble amount; whole rubles drop the zero cents. */
export function formatMinor(
  amountMinor: number,
  currency: string,
  locale: string,
): string {
  const whole = amountMinor % 100 === 0;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  }).format(amountMinor / 100);
}
